// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rating-stars[data-v-2f75920d]{display:flex;flex-direction:row-reverse;justify-content:center}.rating-stars input[data-v-2f75920d]{display:none}.rating-stars-edit :hover~label .rating-star[data-v-2f75920d],.rating-stars :checked~label .rating-star[data-v-2f75920d]{fill:#ffb000}.rating-stars-edit .rating-star[data-v-2f75920d]{cursor:pointer}.rating-star[data-v-2f75920d]{fill:#a8aaaf;transition:.3s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
